<template>
  <path pid="0" d="M21 4H5a3 3 0 00-3 3v2a1 1 0 002 0V7a1 1 0 011-1h16a1 1 0 011 1v12a1 1 0 01-1 1h-6a1 1 0 000 2h6a3 3 0 003-3V7a3 3 0 00-3-3z"/><path pid="1" d="M11.06 22a1 1 0 00.88-1.1 10 10 0 00-8.83-8.83 1 1 0 10-.22 2A8 8 0 0110 21.11a1 1 0 001.06.89z"/><path pid="2" d="M3.2 16.12a1 1 0 10-.4 2 4 4 0 013.12 3.08 1 1 0 002-.4 6 6 0 00-4.72-4.68z"/>
</template>
